import { render, staticRenderFns } from "./StandardInputAuto.vue?vue&type=template&id=5bfb1418&scoped=true"
import script from "./StandardInputAuto.vue?vue&type=script&lang=js"
export * from "./StandardInputAuto.vue?vue&type=script&lang=js"
import style0 from "./StandardInputAuto.vue?vue&type=style&index=0&id=5bfb1418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb1418",
  null
  
)

export default component.exports